function normalizeDiffValue(value: any): any {
  if (Array.isArray(value) && value.length === 1 && value[0] === "") {
    return "";
  }
  return value;
}

export function getObjectDiffMask<T extends object>(prev: T, curr: T): Record<string, boolean> {
  const diff: Record<string, boolean> = {};
  const allKeys = new Set([...Object.keys(prev || {}), ...Object.keys(curr || {})]);
  allKeys.forEach((key) => {
    const prevValue = normalizeDiffValue((prev as any)[key]);
    const currValue = normalizeDiffValue((curr as any)[key]);

    diff[key] = JSON.stringify(prevValue) !== JSON.stringify(currValue);
  });

  return diff;
}

/**
 * Flags every key whose value is not shared by all the rows of the list.
 * Unlike getObjectDiffMask, the comparison is done against the whole set, so the
 * resulting mask is the same for every row: it answers "does this column differ
 * between these rows?" rather than "did this row change since the previous one?".
 */
export function getObjectSetDiffMask<T extends object>(
  list: T[]
): Record<string, boolean> {
  const diff: Record<string, boolean> = {};
  if (!list || list.length < 2) {
    return diff;
  }

  const allKeys = new Set(list.flatMap((item) => Object.keys(item || {})));
  allKeys.forEach((key) => {
    const first = JSON.stringify(normalizeDiffValue((list[0] as any)?.[key]));
    diff[key] = list.some(
      (item) => JSON.stringify(normalizeDiffValue((item as any)?.[key])) !== first
    );
  });

  return diff;
}
